// File generated by NTypewriter using scriban template (_Models.nt), DO NOT MODIFY THIS FILE
/* tslint:disable */
/**
 * 
 */
export enum PartyPosition {

    /**
     *
     */
    Support = 0,

    /**
     *
     */
    Oppose = 1,

    /**
     *
     */
    ConscienceVote = 2,

    /**
     *
     */
    SupportToSelectCommittee = 3
}

/**
 * Property names of this type
 */
export const PartyPosition_DISPLAY_NAMES = {

    /**
     *
     */
    [0]: "'Support'",

    /**
     *
     */
    [1]: "'Oppose'",

    /**
     *
     */
    [2]: "'Conscience Vote'",

    /**
     *
     */
    [3]: "'Support to select committee'"

};


// WEBPACK FOOTER //
// ./src/model/autogen/PartyPosition.ts